import { atom, selector } from "recoil";
import { recoilPersist } from "recoil-persist";
import { v1 } from "uuid";

const { persistAtom } = recoilPersist();
export enum UserState {
  PENDING = "PENDING", // 가입대기
  APPROVED = "APPROVED", // 가입승인
  CANCEL = "CANCEL", // 가입취소
  WITHDRAWAL = "WITHDRAWAL", // 탈퇴처리
}

export interface User {
  id: string;
  userId: string;
  username: string;
  profile: UserProfile;
  profileImg: UserProfileImg;
  createdAt: Date;
  updatedAt: Date;
  state: UserState;
}

export const userState = atom<User | null>({
  key: `user`,
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const userInfoSelector = selector({
  key: `userInfoSelector/${v1()}`,
  get: ({ get }) => {
    return get(userState);
  },
  set: ({ set }, userInfo) => {
    set(userState, userInfo);
  },
});

export const alramState = atom<boolean>({
  key: `alram`,
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const accountFind = atom<{ username: string; phoneNumber: string }>({
  key: `accountFind`,
  default: {
    username: "",
    phoneNumber: "",
  },
});

export interface UserProfile {
  id: string;
  email: string;
  phoneNumber: string;
}

export interface UserProfileImg {
  id: string;
  imagename: string;
  size: number;
  imageUrl: string;
  createdAt: Date;
}
